import React from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import OurServices from '../components/Services';
import NavBar from '../components/Navbar/NavBar';
import { OurApproach } from '../components/OurApproach';


const Home = () => {
    return (
        <>
            <NavBar/>
            <Hero />
            <Intro />
            <OurServices />
            <OurApproach />
            <Clients />
            <Footer />
        </>

    )
}

export default Home;

